export const internal = '~schema';
export type internal = typeof internal;

export const PRIMITIVE_WRAPPER_FIELD_NAME = '__wrappedPrimitive';
